import type { SVGProps } from 'react';
const SvgNotificationImportant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#notification_important_svg__a)">
      <path
        fill="currentColor"
        d="M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2Zm-5 0h-2v-2h2v2Zm0-4h-2V8h2v4Zm-1 10c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Z"
      />
    </g>
    <defs>
      <clipPath id="notification_important_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNotificationImportant;
